import React from 'react';

import Link from 'client/blocks/Link/Link';
import { routes } from 'client/lib/routes';
import { getCanViewAsAdmin } from 'client/utils';

export const NdaLink = () => {
    if (!getCanViewAsAdmin()) return null;

    return (
        <>
            <Link to={routes.documentation.nda} target="_blank">
                NDA
            </Link>
            <span>{` `}</span>
        </>
    );
};
